/*
 * @Description: 全局数据
 * @Date: 2022-03-10 14:26:32
 * @LastEditTime: 2022-03-10 14:28:13
 */
const dataTypes = [
  {
    text: "text",
    value: "text"
  },
  {
    text: "decimal",
    value: "decimal"
  },
  {
    text: "enum",
    value: "enum"
  },
  {
    text: "int32",
    value: "int32"
  },
  {
    text: "int64",
    value: "int64"
  },
  {
    text: "bool",
    value: "bool"
  },
  {
    text: "array",
    value: "array"
  },
  {
    text: "struct",
    value: "struct"
  }
];

export { dataTypes };
